module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.response && _vm.response.status && _vm.response.status != 200 && _vm.response.status != 400) ? _c('el-alert', {
    attrs: {
      "title": "Atenção",
      "type": "error",
      "description": _vm.response.msg,
      "show-icon": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec5ba4d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/error.vue
// module id = 1591
// module chunks = 45